export default __webpack_public_path__ + "71e4ff85d76a1c05252aaa664ea5e14b.svg";